import settings from 'settings'
import { HubspotForm } from '../types'

function baseUrl() {
  return `https://api.hsforms.com/submissions/v3/integration/submit/${settings.hubspotId}`
}

export const postHubspotRequestSubscriptionForm = async (hubspotForm: HubspotForm): Promise<Response> => {
  const form_id = settings.hubspotSubscriptionFormId
  const request = getRequest(form_id, hubspotForm)
  return await fetchRequest(request)
}

export const postHubspotLimitForm = async (hubspotForm: HubspotForm): Promise<Response> => {
  const form_id = settings.hubspotLimitFormId
  const request = getRequest(form_id, hubspotForm)
  return await fetchRequest(request)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRequest(form_id: string, fields: Record<string, any>): Request {
  const url = `${baseUrl()}/${form_id}`

  return new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      fields: Object.entries(fields).map((h) => ({ name: h[0], value: h[1] }))
    })
  })
}

function fetchRequest(request: Request) {
  return fetch(request).then(async (response: Response) => {
    if (response.ok) {
      return response.json()
    } else {
      throw await response.json()
    }
  })
}
